var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91878 21C16.221 21 20.7613 14.0756 20.7613 8.07096C20.7613 7.87431 20.7573 7.67856 20.7485 7.48362C21.6319 6.84008 22.3943 6.04328 23 5.13057C22.1912 5.49255 21.3209 5.73618 20.4079 5.84602C21.3398 5.28348 22.0553 4.39351 22.3928 3.33269C21.5068 3.86184 20.5374 4.23486 19.5266 4.43568C18.703 3.55242 17.5304 3 16.2319 3C13.7393 3 11.718 5.03499 11.718 7.54343C11.718 7.90005 11.7576 8.24682 11.8351 8.57955C8.08369 8.38951 4.75722 6.58133 2.53097 3.83187C2.13 4.52534 1.9191 5.31348 1.9198 6.1158C1.9198 7.69233 2.71663 9.08404 3.92841 9.89828C3.21163 9.87624 2.51057 9.68132 1.8842 9.32993C1.88353 9.349 1.88353 9.36759 1.88353 9.38798C1.88353 11.5886 3.43936 13.426 5.50468 13.8423C5.11678 13.9487 4.71652 14.0025 4.31449 14.0022C4.02415 14.0022 3.74119 13.9735 3.46619 13.9203C4.04083 15.7258 5.70711 17.0397 7.68268 17.0764C6.1378 18.2954 4.19174 19.0215 2.07666 19.0215C1.71686 19.0218 1.35735 19.0008 1 18.9585C2.99762 20.2476 5.36959 20.9997 7.919 20.9997",
    fill: "#697077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.3460a69a.svg";
export { ForwardRef as ReactComponent };